import { PlatformCatalogVersionSortByParam } from "@bvhi/backend-api";
import { GridSortItem } from "@bvhi/ui-base";
import { useCallback } from "react";

export interface SortConfig {
  backendString: string;
  dataGridSortModel: GridSortItem;
}

const config: SortConfig[] = [
  {
    backendString: PlatformCatalogVersionSortByParam.NAME_ASC,
    dataGridSortModel: {
      field: "name",
      sort: "asc",
    },
  },
  {
    backendString: PlatformCatalogVersionSortByParam.NAME_DESC,
    dataGridSortModel: {
      field: "name",
      sort: "desc",
    },
  },
  {
    backendString: PlatformCatalogVersionSortByParam.PUBLISHED_FROM_ASC,
    dataGridSortModel: {
      field: "publishedFrom",
      sort: "asc",
    },
  },
  {
    backendString: PlatformCatalogVersionSortByParam.PUBLISHED_FROM_DESC,
    dataGridSortModel: {
      field: "publishedFrom",
      sort: "desc",
    },
  },
  {
    backendString: PlatformCatalogVersionSortByParam.PUBLISHED_UNTIL_ASC,
    dataGridSortModel: {
      field: "publishedUntil",
      sort: "asc",
    },
  },
  {
    backendString: PlatformCatalogVersionSortByParam.PUBLISHED_UNTIL_DESC,
    dataGridSortModel: {
      field: "publishedUntil",
      sort: "desc",
    },
  },
  {
    backendString: PlatformCatalogVersionSortByParam.VERSION_ASC,
    dataGridSortModel: {
      field: "version",
      sort: "asc",
    },
  },
  {
    backendString: PlatformCatalogVersionSortByParam.VERSION_DESC,
    dataGridSortModel: {
      field: "version",
      sort: "desc",
    },
  },
];

export const useCatalogVersionsSortParams = () => {
  const isFieldSortable = useCallback((fieldName: string): boolean => {
    const configItem = config.find((item) => item.dataGridSortModel.field === fieldName);
    if (configItem) return true;
    return false;
  }, []);

  const getSortModelForBackendString = useCallback((backendString: string): GridSortItem => {
    const item = config.find((item) => item.backendString === backendString);
    return item?.dataGridSortModel ?? config[0].dataGridSortModel;
  }, []);

  const getSortConfig = useCallback((sortModel?: GridSortItem) => {
    if (!sortModel) return config[0];
    const item = config.find((item) => item.dataGridSortModel.field === sortModel.field && item.dataGridSortModel.sort === sortModel.sort);
    return item ?? config[0];
  }, []);

  return { isFieldSortable, getSortConfig, getSortModelForBackendString };
};
